import { Partial } from '@40seas/entities/common';
import { Tenant } from './tenant.entity';

export class UpdateTenantDto extends Partial(Tenant) {}
